export default [
    {
        id: '@cgbpayment',
        path: '/',
        onload: function () { return import('./payment'); },
    }
];
